export default "__VITE_ASSET__CtPh8Ufw__"